<template>
<div>
      <div class="row">
        <div class="col-12">
            <label>{{label}}</label>
        </div>
    </div>

    <div class="row">
        <div class="col-auto">
            <color-picker
                v-bind:color="value"
                v-bind:enabled="enabled"
                v-bind:lastColor="lastValue"
                @change-color="$emit('input', $event)"
                @set-last-color="lastValue = $event"
            />
        </div>
        <div class="col-auto">
            <Checkbox
                v-model="enabled"
                v-bind:text="''"
            />
        </div>
    </div>
</div>
</template>

<script>
    import ColorPicker from '../../../../Components/Util/ColorPicker.vue';
    import SettingsCheckbox from './SettingsCheckbox.vue';

    import resourceMixin from "../../../../Util/Mixins/resources";

    export default {
        name: "settings-color-picker",
        components: {
            ColorPicker,
            'Checkbox' : SettingsCheckbox
        },
        mixins: [resourceMixin],
        computed: {
            enabled: {
                get() {
                    return this.value !== '';
                },
                set(value) {
                    if(value)
                        this.$emit('input', this.lastValue);
                    else 
                        this.$emit('input', '');
                }
            }
        },
        watch: {
            value() {
                this.lastValue = this.value != '' ? this.value : this.lastValue;
            }
        },
        data() {
            return {
                lastValue: ''
            }
        },
        props:{
            label: {
                type: String,
                default: true
            },
            value: {
                type: String,
                required: true
            }
        }
    };
</script>
